import { ParcellairesComponent } from './parcellaires.component';

export const PARCELLAIRES_ROUTES = [
    {
        path: '',
        component: ParcellairesComponent,
        data: {
            role: 'ORGANISME || DECLARATION_INVENTAIRE_VERGER_LECTURE',
            domaines: ['ANPP'],
            menu: {
                libelle: 'menu.parcellaires',
                icon: 'key'
            }
        }
    },
    {
        path: ':idEntreprise',
        component: ParcellairesComponent,
        data: {
            role: 'ORGANISME',
            domaines: ['ANPP']
        }
    },
    {
        path: '',
        component: ParcellairesComponent,
        data: {
            role: 'ORGANISME || DECLARATION_INVENTAIRE_VERGER_LECTURE',
            domaines: ['VIN'],
            menu: {
                libelle: 'menu.parcellaires',
                icon: 'key'
            }
        }
    },
    {
        path: ':idOperateur',
        component: ParcellairesComponent,
        data: {
            role: 'OPERATEUR || DECLARATION_INVENTAIRE_VERGER_LECTURE',
            domaines: ['VIN'],
            menu: {
                libelle: 'menu.parcellaires',
                icon: 'key'
            }
        }
    }
];
